// extracted by css-extract-rspack-plugin
export default {"Box":"no-iterations-placeholder-module__Box__zZeESMt","Text":"no-iterations-placeholder-module__Text__Oma_C2c","Text_1":"no-iterations-placeholder-module__Text_1__nh3qP1i"};